export default {
  management: ['route_management'],
  add: ['route_add'],
  editRoute: ['route_edit'],
  edit: ['route_edit'],
  delete: ['route_delete'],
  archive: ['route_archive']
}
